module.exports = __webpack_public_path__ + "img/global.df546fc8.png";